module.exports = __webpack_public_path__ + "img/main-top.9293ba31.svg";